const defaultState = {
  status: "default",
  data: [],
  detail: {},
  code: 500,
  message: "",
};

let response = {};
const Rumbel_lib = (state = defaultState, action = {}) => {
  switch (action.type) {
    case "SUCCESS_RUMBEL_RUMBEL":
      response = {
        ...state,
        data: action.data ? action.data : {},
        code: action.code ? action.code : 500,
        status: "success",

        message: action.message ? action.message : "",
      };

      break;
    case "LOADING_RUMBEL_RUMBEL":
      response = {
        ...state,
        status: "loading",
      };
      break;
    case "DETAIL_RUMBEL_RUMBEL":
      response = {
        ...state,
        detail: action.detail ? action.detail : {},
        code: action.code ? action.code : 500,
        status: "detail",
        message: action.message ? action.message : "",
      };

      break;
    case "ERROR_RUMBEL_RUMBEL":
      response = {
        ...state,
        status: "error",
        message: action.message ? action.message : "",
        code: action.code ? action.code : 500,
      };
      break;

    default:
      return {
        ...state,
      };
  }

  return response;
};

export default Rumbel_lib;
